module.exports = __webpack_public_path__ + "res/img/download_page_bg_001.e2cdae5b.png";